import "./Forms.css"

import SearchableDropdown from "../../components/SearchableDropdown"
import { useGetClientsBasicDetailsMutation, useGetAccountsBasicDetailsMutation } from "../crm/fileDetails/crmDataApiSlice"
import { useEffect, useState } from "react"
import { showSpinner, hideSpinner } from "../../components/componentSlice"
import { useDispatch, useSelector } from "react-redux"
import { selectCrm } from "../crm/crmSlice"
import FormGenerator from "./FormGenerator"

const EditForms = () => {
    const crm = useSelector(selectCrm)
    
    const [selectedClient, setSelectedClient] = useState(null)
    const [selectedAccount, setSelectedAccount] = useState(null)
    const [clients, setClients] = useState([])
    const [accounts, setAccounts] = useState([])
    const [errorMessage, setErrorMessage] = useState(null)

    const [getClientsBasicDetails, { isLoading: isGetClientsLoading }] = useGetClientsBasicDetailsMutation()
    const [getAccountsBasicDetails, { isLoading: isGetAccountsLoading }] = useGetAccountsBasicDetailsMutation()

    const dispatch = useDispatch()

    useEffect(() => {
        if(isGetClientsLoading || isGetAccountsLoading) {
            dispatch(showSpinner())
        } else{
            dispatch(hideSpinner())
        }
    }, [isGetClientsLoading, isGetAccountsLoading])


    useEffect(() => {
        async function handleGetClients() {
            try {
                const response = await getClientsBasicDetails({ crmId: crm }).unwrap()
                if(response) {
                    setClients(response)
                }
            } catch(err) {
                if(!err.status || err.status === "FETCH_ERROR") {
                    setErrorMessage("No Server Response")
                } else {
                    setErrorMessage(err.data?.detail)
                }
            }
        }
        if(crm) {
            handleGetClients()
        }
    }, [])

    useEffect(() => {
        async function handleGetAccounts() {
            try {
                const response = await getAccountsBasicDetails({ clientId: selectedClient.clientId }).unwrap()
                if(response) {
                    setAccounts(response)
                }
            } catch(err) {
                if(!err.status || err.status === "FETCH_ERROR") {
                    setErrorMessage("No Server Response")
                } else {
                    setErrorMessage(err.data?.detail)
                }
            }
        }
        if(selectedClient) {
            handleGetAccounts()
        }
    }, [selectedClient])

    const getClientOptions = () => {
        return clients.map(client => ({id: client, name: client.firstName + " " + client.lastName}))
    }

    const getAccountOptions = () => {
        return accounts.map(account => ({id: account, name: account.accountType + " - " + account.accountNumber}))
    }

    const onChangeSelectedClient = (id) => {
        setSelectedClient(id)
        setSelectedAccount(null)
    }

    return(
        <div className="table-page-container">
            {errorMessage && 
                <div className="support-error">
                    <p>{errorMessage}</p>
                </div>
            }
            <div className="forms-header">
                <div className='top-header'>
                    <header>Edit Forms</header>
                </div>
            </div>
            <div className="forms-fields">
                <div className="search-dropdown">
                    <SearchableDropdown
                        options={getClientOptions()}
                        label="name"
                        id="id"
                        selectedVal={selectedClient ? selectedClient.firstName + " " + selectedClient.lastName : null}
                        placeholderVal={"Select Client..."}
                        handleChange={(val, id) => onChangeSelectedClient(id)}
                    />
                </div>
                <div className="search-dropdown">
                    <SearchableDropdown
                        options={getAccountOptions()}
                        label="name"
                        id="id"
                        selectedVal={selectedAccount ? selectedAccount.accountType + " - " + selectedAccount.accountNumber : null}
                        placeholderVal={"Select Account..."}
                        handleChange={(val, id) => setSelectedAccount(id)}
                    />
                </div>
            </div>
            {
                <FormGenerator
                    crmId={crm}
                    clientId={selectedClient?.clientId} 
                    accountId={selectedAccount?.accountId}  
                />
            }
        </div>
    )
}

export default EditForms